export const getErrorArray = (response) => {
  const messageData = response?.data?.message;

  if (!messageData || !Array.isArray(messageData)) {
    return [];
  }

  return messageData.map((msg) => ({
    ...msg,
    name: msg.field,
    errors: [msg.error],
  }));
};

export const getErrorMessage = (response) => {
  const messageData = response?.data?.message;

  if (!messageData) {
    return response?.message || '';
  }

  if (Array.isArray(messageData)) {
    return messageData[0].error;
  } else {
    return messageData;
  }
};

export const isUnauthorized = (response) => {
  return response?.status === 401;
};
